<h1 mat-dialog-title class="p-2 text-center">Nouvelle mesure </h1>
<div class="p-3">
    <div class="col">
        <div class="">
            <div class="row">
                <mat-form-field class="col">
                    <mat-label>Distance berge (m)</mat-label>
                    <input matInput placeholder="Distance berge (m)" type="number" [(ngModel)]="NewPrelevement.DistanceBerge" [formControl]="ValidDistanceMax">
                    <mat-error *ngIf="ValidDistanceMax.hasError('max')">
                        Max {{DMAX}}m
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col">
                    <mat-label>Profondeur (cm)</mat-label>
                    <input matInput placeholder="Profondeur (cm)" type="number" [(ngModel)]="NewPrelevement.Profondeur" [formControl]="ValidProfMax">
                    <mat-error *ngIf="ValidProfMax.hasError('max')">
                        Max {{PMAX}}cm
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="row">
                <button class="col mx-3 my-2" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="accent" (throttledClick)="onCancel()" >
                    Annuler<mat-icon>undo</mat-icon>
                </button>
            </div>
            <div class="row">
                <button class="col mx-3 my-2" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="primary" (throttledClick)="onConfirm()" [disabled]="!CanAddNewMeasure()">
                    Enregistrer<mat-icon>save</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>